import WizrFlexLayout from '../WizrFlexLayout'
import WizrText from '../WizrText'
import styled from 'styled-components'
import WarningIcon from '../../assets/icons/WarningIcon'

const WarningIconWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 16px;
  .anticon {
    font-size: 48px;
    color: #fa8c16;
  }
`

const BodyText = styled.div`
  text-align: center;
  margin-bottom: 16px;
`

const formatTypeLabel = (type: string): string => {
  if (!type || typeof type !== 'string') return ''
  const lower = type.toLowerCase()
  if (lower === 'llm') return 'LLM'
  return type.charAt(0).toUpperCase() + type.slice(1).toLowerCase()
}

interface IImportWorkflowWarning {
  cleanedTypes?: string[]
  onClose?: () => void
}

const ImportWorkflowWarning = ({ cleanedTypes = [], onClose }: IImportWorkflowWarning): JSX.Element => {
  const formattedTypes = (cleanedTypes ?? []).map(formatTypeLabel).filter(Boolean)
  const titleText = formattedTypes.join(', ')

  return (
    <WizrFlexLayout flexDirection='column' alignItems='stretch' background='#FFF' style={{ padding: '8px 0' }}>
      <WarningIconWrapper>
        <WarningIcon />
      </WarningIconWrapper>
      <WizrText type='sub1' style={{ textAlign: 'center', marginBottom: 12, fontWeight: 600 }}>
        {titleText ? `${titleText} must be Imported Separately` : 'Import Completed'}
      </WizrText>
      <BodyText>
        <WizrText type='body1'>
          The following block types were not included in this import. When re-importing or configuring this workflow,
          ensure these are imported or configured separately as needed.
        </WizrText>
      </BodyText>
    </WizrFlexLayout>
  )
}

export default ImportWorkflowWarning
